<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-toolbar flat>
                <v-toolbar-title>Report Sales dan Tester</v-toolbar-title>
                <v-divider class="mx-4" inset vertical />
                <v-spacer />
                <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
            </v-toolbar>
            <div class="mt-3">
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Type</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-select outlined dense hide-details="auto" :items="typeReport" item-value="code" item-text="name" v-model="selectedTypeReport" class="compact-form" @change="handleChangeType"></v-select>
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Start Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="startDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="start_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="start_date" @change="handelChangeStartDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">End Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="endDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="end_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="end_date" @change="handelChangeEndDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row class="compact-form my-2 mx-1">
                    <v-col>
                        <v-card outlined>
                            <v-skeleton-loader v-if="isLoading"
                                v-bind="$attrs"
                                type="table-tbody">
                            </v-skeleton-loader>
                            <v-simple-table v-else fixed-header height="400" ref="tabelExport">
                                <template v-slot:default class="">
                                    <thead>
                                        <tr>
                                            <th class="header-cell" style="width:5px;">No.</th>
                                            <th class="header-cell">Kode Customer (40)(*)</th>
                                            <th class="header-cell">Tgl S.O. (dd/MM/yyyy) (*)</th>
                                            <th class="header-cell">PO Customer</th>
                                            <th class="header-cell">Tgl Kirim (dd/MM/yyyy)</th>
                                            <th class="header-cell">Kode Gudang (*)</th>
                                            <th class="header-cell">Kode Barang (40) (*)</th>
                                            <th class="header-cell">Nama Barang</th>
                                            <th class="header-cell">Catatan Per Item</th>
                                            <th class="header-cell">Qty (*)</th>
                                            <th class="header-cell">Transaksi Sample (0/1)</th>
                                            <th class="header-cell">Tipe Sample(Tester/Complimen)</th>
                                            <th class="header-cell">Kode Customer Sample (40)</th>
                                            <th class="header-cell">Kode Driver</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, idx) in items" :key="idx">
                                            <td>{{ idx + 1 }}</td>
                                            <td class="text-no-wrap">{{ item.outlet_code }}</td>
                                            <td class="text-no-wrap">{{ item.delivery_date }}</td>
                                            <td></td>
                                            <td class="text-no-wrap">{{ item.delivery_date }}</td>
                                            <td>ZIRCON</td>
                                            <td class="text-no-wrap">{{ item.product_code }}</td>
                                            <td class="text-no-wrap">{{ item.product_name }}</td>
                                            <td></td>
                                            <td class="text-no-wrap">{{ item.quantity }}</td>
                                            <td class="text-no-wrap">{{ item.transaksi_sample }}</td>
                                            <td class="text-no-wrap">{{ item.tipe_sample }}</td>
                                            <td class="text-no-wrap">{{ item.outlet_code_sample }}</td>
                                            <td class="text-no-wrap">{{ item.line }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            start_date: '',
            startDateMenu: false,
            end_date: '',
            endDateMenu: false,
            headers: [],
            items: [],
            isLoading: false,
            selectedTypeReport: 'sales',
            typeReport: [
                { code: 'sales', name: 'Sales '},
                { code: 'tester', name: 'Tester' }
            ]
        }
    },

    async created() {
        this.fetchData();
    },

    methods: {
        handelChangeStartDate() {
            this.fetchData();
        },
        handelChangeEndDate() {
            this.fetchData();
        },
        handleChangeType() {
            this.fetchData();
        },

        async fetchData() {
            this.isLoading = true;

            try {
                const response = (await this.$store.dispatch('getObjs', {
                    apidomain: `report-sales`,
                    parameter: `?type=${this.selectedTypeReport}&start_date=${this.start_date}&end_date=${this.end_date}`
                }));

                const data = response.data.data;
                this.start_date = data.start_date;
                this.end_date = data.end_date;
                this.items = data.items;
            } catch (error) {
                console.log('Error fetching report sales : ', error);
            } finally {
                this.isLoading = false;
            }
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tabelExport.$el.firstChild.firstChild);
            let fileName = 'Report-Sales.xlsx';

            if (this.selectedType == 'tester') {
                fileName = 'Report-Tester.xlsx';
            }

            writeFileXLSX(wb, fileName);
        },
    }
}
</script>